module.exports = __webpack_public_path__ + "img/00006.7b7fcb35.webp";